import { lazy } from 'react';
import { Routes as configRoutes } from '../config/Routes';

const SignIn = lazy(() => import('../pages/Session/SignIn'));
const AuthScanQR = lazy(() => import('../pages/Session/AuthScanQR'));
const AuthMFA = lazy(() => import('../pages/Session/AuthMFA'));
const ResetPass = lazy(() => import('../pages/Session/ResetPass'));

export default [
  {
    Component: SignIn,
    path: configRoutes.SIGN_IN,
  },
  {
    Component: AuthScanQR,
    path: configRoutes.AUTH_QR,
  },
  {
    Component: AuthMFA,
    path: configRoutes.AUTH_MFA,
  },
  {
    Component: ResetPass,
    path: configRoutes.RESET_PASS,
  },
];
